import { createStore } from "vuex";
import TicketNotificationService from "../services/Notification/TicketNotificationService";

//const tabId = Math.random().toString(36).slice(2);
const syncChannel = new BroadcastChannel('storeSync');

const store = createStore({
  state: {
    //tabId: tabId,
    hideConfigButton: true,
    isPinned: true,
    showConfig: false,
    sidebarType: "bg-white",
    isRTL: true,
    mcolor: "card-background-mask-dark",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showSidenavFooter: false,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    layout: "default",
    topPageColorClass: "bg-purple-gradiant",
    appVersion: "1.5.0 Beta",
    app_title: "سامانه جامع تیکتینگ",
    company_title: "شرکت ویرا نوین نیک آمد",
    //$api_base_url: 'http://karamadapi.basaco.ir/api/',
    //$api_base_url: 'https://localhost:44362/',
    //$api_base_url: 'https://spapi.weinno.ir/',
    //$api_base_url: 'https://karamadapi.behdasht.gov.ir/api/',
    //$api_base_url: 'https://supportapi.weinno.ir/',
    $api_base_url: '/api/',
    //$api_base_url: '/api',
    currentUserInfo: {
      //user_name: '',
      //token: '',
      //userId: 0,
      //postTitle: '',
      //firstName: '',
      //lastName: '',
      //dataAccessLevel: 1,
      //permissions: [],
      //accessItems: [],
      //companyId: 2,
      //companyTitle: '',
      //customerTitle: '',
      //userRoleTitle: '',
      //RoleTitle: '',
      //RolePermissionTitle: '',
      permissions: [],
    },
    newReferralNotifications: [],
    myTicketsNotifications: [],
    comprehensiveReportFilters: {},
    comprehensiveReportResults: [],
    // form_access_info: {
    //   failResult: {
    //     canView: false,
    //     canInsert: false,
    //     canUpdate: false,
    //     canDelete: false,
    //     canUndo_delete: false,
    //     canSearch: false,
    //     canPrint: false
    //   },
    //   successResult: {
    //     canView: true,
    //     canInsert: true,
    //     canUpdate: true,
    //     canDelete: true,
    //     canUndo_delete: true,
    //     canSearch: true,
    //     canPrint: true
    //   }
    // },
    defaultPageSize: 25,
    // ministryPerms: [],
    // universityPerms: [],
    // hospitalPerms: [],
    // maxOpenYear: 1403,
    // selectedApplyDate: null,
    routeHistory: [],
    lastRoute: '/main',
    // helps: {
    //   textHelpAfterStartFollow: 'پس از شروع روند تاییدات، اطلاعات قفل شده و امکان ویرایش اطلاعات میسر نمی باشد، مگر در صورت رد اطلاعات توسط یکی از تایید کنندگان',
    //   textHelpForPriodData_UpdataIfExists: 'در صورت وجود اطلاعات در ماه انتخاب شده برای پارامتر انتخاب شده، اطلاعات قبلی حذف و اطلاعات جدید ثبت خواهد شد'
    // },
    routeParams: {
      personDataEdit: '',
      calculateId: 0,
      data: ''
    },
    refCount: 0,
    isLoading: false,
    // listSymbolParams: [
    //   { id: 378, code: 1001, symbol: 'ia23', order: 1.20 }, { id: 379, code: 1001, symbol: 'da23', order: 1.20 }, { id: 380, code: 1001, symbol: 'ib23', order: 1.20 }, { id: 381, code: 1001, symbol: 'db23', order: 1.20 }, { id: 286, code: 1001, symbol: 'ia1', order: 1.10 }, { id: 287, code: 1001, symbol: 'da1', order: 1.10 }, { id: 288, code: 1001, symbol: 'ib1', order: 1.10 }, { id: 289, code: 1001, symbol: 'db1', order: 1.10 },
    //   { id: 290, code: 2001, symbol: 'ia2', order: 2.10 }, { id: 291, code: 2001, symbol: 'da2', order: 2.10 }, { id: 292, code: 2001, symbol: 'ib2', order: 2.10 }, { id: 293, code: 2001, symbol: 'db2', order: 2.10 }, { id: 382, code: 2001, symbol: 'ia24', order: 2.20 }, { id: 383, code: 2001, symbol: 'da24', order: 2.20 }, { id: 384, code: 2001, symbol: 'ib24', order: 2.20 }, { id: 385, code: 2001, symbol: 'db24', order: 2.20 },
    //   { id: 294, code: 3001, symbol: 'ia3', order: 3.10 }, { id: 295, code: 3001, symbol: 'da3', order: 3.10 }, { id: 296, code: 3001, symbol: 'ib3', order: 3.10 }, { id: 297, code: 3001, symbol: 'db3', order: 3.10 }, { id: 386, code: 3001, symbol: 'ia25', order: 3.20 }, { id: 387, code: 3001, symbol: 'da25', order: 3.20 }, { id: 388, code: 3001, symbol: 'ib25', order: 3.20 }, { id: 389, code: 3001, symbol: 'db25', order: 3.20 },
    //   { id: 390, code: 4001, symbol: 'ia26', order: 4.20 }, { id: 391, code: 4001, symbol: 'da26', order: 4.20 }, { id: 392, code: 4001, symbol: 'ib26', order: 4.20 }, { id: 393, code: 4001, symbol: 'db26', order: 4.20 }, { id: 298, code: 4001, symbol: 'ia4', order: 4.10 }, { id: 299, code: 4001, symbol: 'da4', order: 4.10 }, { id: 300, code: 4001, symbol: 'ib4', order: 4.10 }, { id: 301, code: 4001, symbol: 'db4', order: 4.10 },
    //   { id: 302, code: 5001, symbol: 'ia5', order: 5.10 }, { id: 303, code: 5001, symbol: 'da5', order: 5.10 }, { id: 304, code: 5001, symbol: 'ib5', order: 5.10 }, { id: 305, code: 5001, symbol: 'db5', order: 5.10 }, { id: 394, code: 5001, symbol: 'ia27', order: 5.20 }, { id: 395, code: 5001, symbol: 'da27', order: 5.20 }, { id: 396, code: 5001, symbol: 'ib27', order: 5.20 }, { id: 397, code: 5001, symbol: 'db27', order: 5.20 },
    //   { id: 398, code: 6001, symbol: 'ia28', order: 6.20 }, { id: 399, code: 6001, symbol: 'da28', order: 6.20 }, { id: 400, code: 6001, symbol: 'ib28', order: 6.20 }, { id: 401, code: 6001, symbol: 'db28', order: 6.20 }, { id: 306, code: 6001, symbol: 'ia6', order: 6.10 }, { id: 307, code: 6001, symbol: 'da6', order: 6.10 }, { id: 308, code: 6001, symbol: 'ib6', order: 6.10 }, { id: 309, code: 6001, symbol: 'db6', order: 6.10 },
    //   { id: 310, code: 7001, symbol: 'ia7', order: 7.10 }, { id: 311, code: 7001, symbol: 'da7', order: 7.10 }, { id: 312, code: 7001, symbol: 'ib7', order: 7.10 }, { id: 313, code: 7001, symbol: 'db7', order: 7.10 }, { id: 402, code: 7001, symbol: 'ia29', order: 7.20 }, { id: 403, code: 7001, symbol: 'da29', order: 7.20 }, { id: 404, code: 7001, symbol: 'ib29', order: 7.20 }, { id: 405, code: 7001, symbol: 'db29', order: 7.20 },
    //   { id: 406, code: 8001, symbol: 'ia30', order: 8.40 }, { id: 407, code: 8001, symbol: 'da30', order: 8.40 }, { id: 408, code: 8001, symbol: 'ib30', order: 8.40 }, { id: 409, code: 8001, symbol: 'db30', order: 8.40 }, { id: 314, code: 8001, symbol: 'ia8', order: 8.20 }, { id: 315, code: 8001, symbol: 'da8', order: 8.20 }, { id: 316, code: 8001, symbol: 'ib8', order: 8.20 }, { id: 317, code: 8001, symbol: 'db8', order: 8.20 },
    //   { id: 318, code: 9001, symbol: 'ia9', order: 9.10 }, { id: 319, code: 9001, symbol: 'da9', order: 9.10 }, { id: 320, code: 9001, symbol: 'ib9', order: 9.10 }, { id: 321, code: 9001, symbol: 'db9', order: 9.10 }, { id: 410, code: 9001, symbol: 'ia31', order: 9.20 }, { id: 411, code: 9001, symbol: 'da31', order: 9.20 }, { id: 412, code: 9001, symbol: 'ib31', order: 9.20 }, { id: 413, code: 9001, symbol: 'db31', order: 9.20 },
    //   { id: 322, code: 10001, symbol: 'ia10', order: 10.10 }, { id: 323, code: 10001, symbol: 'da10', order: 10.10 }, { id: 324, code: 10001, symbol: 'ib10', order: 10.10 }, { id: 325, code: 10001, symbol: 'db10', order: 10.10 }, { id: 414, code: 10001, symbol: 'ia32', order: 10.20 }, { id: 415, code: 10001, symbol: 'da32', order: 10.20 }, { id: 416, code: 10001, symbol: 'ib32', order: 10.20 }, { id: 417, code: 10001, symbol: 'db32', order: 10.20 },
    //   { id: 326, code: 11001, symbol: 'ia11', order: 11.10 }, { id: 327, code: 11001, symbol: 'da11', order: 11.10 }, { id: 328, code: 11001, symbol: 'ib11', order: 11.10 }, { id: 329, code: 11001, symbol: 'db11', order: 11.10 }, { id: 418, code: 11001, symbol: 'ia33', order: 11.20 }, { id: 419, code: 11001, symbol: 'da33', order: 11.20 }, { id: 420, code: 11001, symbol: 'ib33', order: 11.20 }, { id: 421, code: 11001, symbol: 'db33', order: 11.20 },
    //   { id: 422, code: 12001, symbol: 'ia34', order: 12.20 }, { id: 423, code: 12001, symbol: 'da34', order: 12.20 }, { id: 424, code: 12001, symbol: 'ib34', order: 12.20 }, { id: 425, code: 12001, symbol: 'db34', order: 12.20 }, { id: 330, code: 12001, symbol: 'ia12', order: 12.10 }, { id: 331, code: 12001, symbol: 'da12', order: 12.10 }, { id: 332, code: 12001, symbol: 'ib12', order: 12.10 }, { id: 333, code: 12001, symbol: 'db12', order: 12.10 },
    //   { id: 334, code: 13001, symbol: 'ia13', order: 13.10 }, { id: 335, code: 13001, symbol: 'da13', order: 13.10 }, { id: 336, code: 13001, symbol: 'ib13', order: 13.10 }, { id: 337, code: 13001, symbol: 'db13', order: 13.10 }, { id: 426, code: 13001, symbol: 'ia35', order: 13.20 }, { id: 427, code: 13001, symbol: 'da35', order: 13.20 }, { id: 428, code: 13001, symbol: 'ib35', order: 13.20 }, { id: 429, code: 13001, symbol: 'db35', order: 13.20 },
    //   { id: 430, code: 14001, symbol: 'ia36', order: 14.20 }, { id: 431, code: 14001, symbol: 'da36', order: 14.20 }, { id: 432, code: 14001, symbol: 'ib36', order: 14.20 }, { id: 433, code: 14001, symbol: 'db36', order: 14.20 }, { id: 338, code: 14001, symbol: 'ia14', order: 14.10 }, { id: 339, code: 14001, symbol: 'da14', order: 14.10 }, { id: 340, code: 14001, symbol: 'ib14', order: 14.10 }, { id: 341, code: 14001, symbol: 'db14', order: 14.10 },
    //   { id: 342, code: 15001, symbol: 'ia15', order: 15.10 }, { id: 343, code: 15001, symbol: 'da15', order: 15.10 }, { id: 344, code: 15001, symbol: 'ib15', order: 15.10 }, { id: 345, code: 15001, symbol: 'db15', order: 15.10 }, { id: 434, code: 15001, symbol: 'ia37', order: 15.20 }, { id: 435, code: 15001, symbol: 'da37', order: 15.20 }, { id: 436, code: 15001, symbol: 'ib37', order: 15.20 }, { id: 437, code: 15001, symbol: 'db37', order: 15.20 },
    //   { id: 438, code: 16001, symbol: 'ia38', order: 16.20 }, { id: 439, code: 16001, symbol: 'da38', order: 16.20 }, { id: 440, code: 16001, symbol: 'ib38', order: 16.20 }, { id: 441, code: 16001, symbol: 'db38', order: 16.20 }, { id: 346, code: 16001, symbol: 'ia16', order: 16.10 }, { id: 347, code: 16001, symbol: 'da16', order: 16.10 }, { id: 348, code: 16001, symbol: 'ib16', order: 16.10 }, { id: 349, code: 16001, symbol: 'db16', order: 16.10 },
    //   { id: 350, code: 17001, symbol: 'ia17', order: 17.10 }, { id: 351, code: 17001, symbol: 'da17', order: 17.10 }, { id: 352, code: 17001, symbol: 'ib17', order: 17.10 }, { id: 353, code: 17001, symbol: 'db17', order: 17.10 }, { id: 442, code: 17001, symbol: 'ia39', order: 17.20 }, { id: 443, code: 17001, symbol: 'da39', order: 17.20 }, { id: 444, code: 17001, symbol: 'ib39', order: 17.20 }, { id: 445, code: 17001, symbol: 'db39', order: 17.20 },
    //   { id: 446, code: 18001, symbol: 'ia40', order: 18.20 }, { id: 447, code: 18001, symbol: 'da40', order: 18.20 }, { id: 448, code: 18001, symbol: 'ib40', order: 18.20 }, { id: 449, code: 18001, symbol: 'db40', order: 18.20 }, { id: 354, code: 18001, symbol: 'ia18', order: 18.10 }, { id: 355, code: 18001, symbol: 'da18', order: 18.10 }, { id: 356, code: 18001, symbol: 'ib18', order: 18.10 }, { id: 357, code: 18001, symbol: 'db18', order: 18.10 },
    //   { id: 358, code: 19001, symbol: 'ia19', order: 19.10 }, { id: 359, code: 19001, symbol: 'da19', order: 19.10 }, { id: 360, code: 19001, symbol: 'ib19', order: 19.10 }, { id: 361, code: 19001, symbol: 'db19', order: 19.10 }, { id: 450, code: 19001, symbol: 'ia41', order: 19.20 }, { id: 451, code: 19001, symbol: 'da41', order: 19.20 }, { id: 452, code: 19001, symbol: 'ib41', order: 19.20 }, { id: 453, code: 19001, symbol: 'db41', order: 19.20 },
    //   { id: 454, code: 20001, symbol: 'ia42', order: 20.20 }, { id: 455, code: 20001, symbol: 'da42', order: 20.20 }, { id: 456, code: 20001, symbol: 'ib42', order: 20.20 }, { id: 457, code: 20001, symbol: 'db42', order: 20.20 }, { id: 362, code: 20001, symbol: 'ia20', order: 20.10 }, { id: 363, code: 20001, symbol: 'da20', order: 20.10 }, { id: 364, code: 20001, symbol: 'ib20', order: 20.10 }, { id: 365, code: 20001, symbol: 'db20', order: 20.10 },
    //   { id: 458, code: 43001, symbol: 'ia43', order: 21.20 }, { id: 459, code: 43001, symbol: 'da43', order: 21.20 }, { id: 460, code: 43001, symbol: 'ib43', order: 21.20 }, { id: 461, code: 43001, symbol: 'db43', order: 21.20 }, { id: 613, code: 43001, symbol: 'ia50', order: 21.10 }, { id: 614, code: 43001, symbol: 'da50', order: 21.10 }, { id: 615, code: 43001, symbol: 'ib50', order: 21.10 }, { id: 616, code: 43001, symbol: 'db50', order: 21.10 },
    //   { id: 366, code: 21001, symbol: 'ia21', order: 22.10 }, { id: 367, code: 21001, symbol: 'da21', order: 22.10 }, { id: 368, code: 21001, symbol: 'ib21', order: 22.10 }, { id: 369, code: 21001, symbol: 'db21', order: 22.10 }, { id: 605, code: 21001, symbol: 'ia46', order: 22.20 }, { id: 606, code: 21001, symbol: 'da46', order: 22.20 }, { id: 607, code: 21001, symbol: 'ib46', order: 22.20 }, { id: 608, code: 21001, symbol: 'db46', order: 22.20 },
    //   { id: 609, code: 22001, symbol: 'ia47', order: 23.20 }, { id: 610, code: 22001, symbol: 'da47', order: 23.20 }, { id: 611, code: 22001, symbol: 'ib47', order: 23.20 }, { id: 612, code: 22001, symbol: 'db47', order: 23.20 }, { id: 370, code: 22001, symbol: 'ia22', order: 23.10 }, { id: 371, code: 22001, symbol: 'da22', order: 23.10 }, { id: 372, code: 22001, symbol: 'ib22', order: 23.10 }, { id: 373, code: 22001, symbol: 'db22', order: 23.10 },
    //   { id: 374, code: 45001, symbol: 'ia45', order: 24.10 }, { id: 375, code: 45001, symbol: 'da45', order: 24.10 }, { id: 376, code: 45001, symbol: 'ib45', order: 24.10 }, { id: 377, code: 45001, symbol: 'db45', order: 24.10 }, { id: 617, code: 45001, symbol: 'ia48', order: 24.20 }, { id: 618, code: 45001, symbol: 'da48', order: 24.20 }, { id: 619, code: 45001, symbol: 'ib48', order: 24.20 }, { id: 620, code: 45001, symbol: 'db48', order: 24.20 },
    //   { id: 621, code: 44001, symbol: 'ia49', order: 25.20 }, { id: 622, code: 44001, symbol: 'da49', order: 25.20 }, { id: 623, code: 44001, symbol: 'ib49', order: 25.20 }, { id: 624, code: 44001, symbol: 'db49', order: 25.20 }, { id: 462, code: 44001, symbol: 'ia44', order: 25.10 }, { id: 463, code: 44001, symbol: 'da44', order: 25.10 }, { id: 464, code: 44001, symbol: 'ib44', order: 25.10 }, { id: 465, code: 44001, symbol: 'db44', order: 25.10 },
    //   { id: 10637, code: 46001, symbol: 'ia51', order: 26.10 }, { id: 10638, code: 46001, symbol: 'da51', order: 26.10 }, { id: 10639, code: 46001, symbol: 'ib51', order: 26.10 }, { id: 10640, code: 46001, symbol: 'db51', order: 26.10 }, { id: 10641, code: 46001, symbol: 'ia52', order: 26.20 }, { id: 10642, code: 46001, symbol: 'da52', order: 26.20 }, { id: 10643, code: 46001, symbol: 'ib52', order: 26.20 }, { id: 10644, code: 46001, symbol: 'db52', order: 26.20 },
    // ],
    // listParameterGroups: [
    //   { id: 1, parameterGroupEnum: 1, title: "ضرایب ضوابط اجرایی دستورالعمل" },
    //   { id: 2, parameterGroupEnum: 0, title: "تنظیمات کلی" },
    //   { id: 3, parameterGroupEnum: 2, title: "تنظیمات به ازای هر بیمارستان" },
    //   { id: 4, parameterGroupEnum: 3, title: "تنظیمات به ازای هر پزشک" },
    //   { id: 5, parameterGroupEnum: 4, title: "امتیاز کیفی" },
    //   { id: 7, parameterGroupEnum: 5, title: "امتیاز سابقه خدمت" },
    //   { id: 8, parameterGroupEnum: 6, title: "امتیاز نمره کیفی پزشکان" },
    //   { id: 10, parameterGroupEnum: 7, title: "امتیاز نمره کیفی گروه پرستاری" },
    //   { id: 11, parameterGroupEnum: 8, title: "ثبت امتیاز حضور پرسنل غیرپرستار" },
    //   { id: 12, parameterGroupEnum: 9, title: " جز حرفه ای پزشکان" },
    //   { id: 13, parameterGroupEnum: 10, title: "جدول پلکانی پزشکان متخصص" },
    //   { id: 14, parameterGroupEnum: 11, title: "جدول پلکانی پزشکان عمومی" },
    //   { id: 15, parameterGroupEnum: 12, title: "جدول پلکانی کارشناسان پروانه دار" },
    //   { id: 16, parameterGroupEnum: 22, title: "تنظیمات ضرایب  پیش فرض برای همه بیمارستانها" },
    //   { id: 17, parameterGroupEnum: 33, title: "تنظیمات ضرایب  پیش فرض برای همه پزشکان" },
    //   { id: 18, parameterGroupEnum: 71, title: "امتیاز نمره کیفی گروه پرسنل غیر پرستاری" },
    //   { id: 19, parameterGroupEnum: 13, title: "درآمد بیمارستان" },
    //   { id: 20, parameterGroupEnum: 14, title: "اطلاعات نمره کیفی پزشکان" },
    //   { id: 21, parameterGroupEnum: 15, title: "اطلاعات نمره کیفی گروه پرستاری" },
    //   { id: 22, parameterGroupEnum: 16, title: "اطلاعات نمره کیفی گروه پرسنل غیرپرستار" },
    //   { id: 23, parameterGroupEnum: 17, title: "بررسی نتیجه محاسبات" },
    //   { id: 24, parameterGroupEnum: 18, title: "اطلاعات امتیاز عملکرد گروه پرستاری" },
    //   { id: 25, parameterGroupEnum: 23, title: "وضعیت تمام وقت /پاره وقت" },
    //   { id: 26, parameterGroupEnum: 19, title: "تنظیمات کلی - به ازای هر بیمارستان" },
    //   { id: 27, parameterGroupEnum: 20, title: "ضرایب ضوابط اجرایی دستورالعمل - به ازای هر بیمارستان" },
    //   { id: 28, parameterGroupEnum: 24, title: "وضعیت ماندگاری پزشک" },
    //   { id: 29, parameterGroupEnum: 25, title: "تشویقی از محل سهم مدیریت" },
    //   { id: 30, parameterGroupEnum: 26, title: "تشویقی ترویج زایمان طبیعی" },
    //   { id: 31, parameterGroupEnum: 27, title: "حق فنی بیمارستان" },
    //   { id: 32, parameterGroupEnum: 28, title: "حق فنی مسئول پاراکلینیک" },
    //   { id: 33, parameterGroupEnum: 29, title: "کارانه دستیار (برای دستیاران)" },
    //   { id: 34, parameterGroupEnum: 30, title: "کارانه کلینیک ویژه مستقل" },
    //   { id: 35, parameterGroupEnum: 31, title: "ضرایب پارامترهای عملکرد پرستاری" },
    //   { id: 36, parameterGroupEnum: 32, title: "اطلاعات امتیاز پارامترهای عملکرد پرسنل پرستاری" },
    //   { id: 37, parameterGroupEnum: 34, title: "اطلاعات امتیاز بخش های حاد و مزمن" },
    //   { id: 38, parameterGroupEnum: 35, title: "دیتای ماهیانه ساعت موظف پایه فرد در ماه" },
    //   { id: 39, parameterGroupEnum: 36, title: "دیتای ماهیانه میزان حضور در سمت" },
    //   { id: 40, parameterGroupEnum: 37, title: "دیتای ماهیانه اطلاعات عملکرد گروه پرستاری با عملکرد مستقیم" },
    //   { id: 41, parameterGroupEnum: 38, title: "افزایش امتیاز نوع خدمت و تعیین سقف مبلغ برای مشاغل خاص" }
    // ],
    exportButtonTitle: 'دریافت خروجی از جدول'
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");

      if (sidenav_show.classList.contains("g-sidenav-hidden")) {
        sidenav_show.classList.remove("g-sidenav-hidden");
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      }

    },
    sidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    setCurrentUserInfo(state, currentUserInfo) {
      state.currentUserInfo = { ...state.currentUserInfo, ...currentUserInfo };
    },
    resetCurrentUserInfo(state){
      state.currentUserInfo.token = null;
      state.currentUserInfo.permissions = [];
      state.currentUserInfo.companies = null;
      state.currentUserInfo.customers = null;
    },
    loading(state, isLoading) {
      if (isLoading) {
        state.refCount++;
        state.isLoading = true;
      } else if (state.refCount > 0) {
        state.refCount--;
        state.isLoading = (state.refCount > 0);
      }
    },
    setTicketFilters(state, filters) {
      state.ticketFilters = {...state.ticketFilters, ...filters};
    },
    resetTicketFilters(state) {
      state.ticketFilters = null;
    },
    setComprehensiveReportFilters(state, filters) {
      state.comprehensiveReportFilters = filters;
    },
    resetComprehensiveReportFilters(state) {
      state.comprehensiveReportFilters = {};
    },
    setComprehensiveReportResults(state, results) {
      state.comprehensiveReportResults = results;
    },
    resetComprehensiveReportResults(state) {
      state.comprehensiveReportResults = [];
    },
    addListNewReferralNotifications(state, notifications) {
      if (notifications != null & notifications.length > 0) {
        let currentTicketIds = state.newReferralNotifications.map(rn => rn.ticketId);
        
        notifications = notifications.filter((value, index, array) => index == array.findIndex(n => n.ticketId == value.ticketId))
                                     .filter(n => currentTicketIds.indexOf(n.ticketId) < 0);
                                     
        state.newReferralNotifications = [...state.newReferralNotifications, ...notifications];
      }
    },
    addListMyTicketsNotifications(state, notifications) {
      if (notifications != null & notifications.length > 0) {
        let currentTicketIds = state.myTicketsNotifications.map(rn => rn.ticketId);
        
        notifications = notifications.filter((value, index, array) => index == array.findIndex(n => n.ticketId == value.ticketId))
                                     .filter(n => currentTicketIds.indexOf(n.ticketId) < 0);
                                     
        state.myTicketsNotifications = [...state.myTicketsNotifications, ...notifications];
      }
    },
    removefromMyTicketsNotifications(state, payload) {
      state.myTicketsNotifications = state.myTicketsNotifications.filter(rn => !(payload.ticketIds.includes(rn.ticketId)));
    },
    removefromReferredTicketsNotifications(state, payload) {
      state.newReferralNotifications = state.newReferralNotifications.filter(rn => !(payload.ticketIds.includes(rn.ticketId)));
    },
    emptyNotificationLists(state) {
      state.myTicketsNotifications = [];
      state.newReferralNotifications = [];
    }
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
    setCurrentUserInfo(context, payload) {
      context.commit('setCurrentUserInfo', payload);
    },
    resetCurrentUserInfo(context){
      context.commit('resetCurrentUserInfo');
    },
    setTicketFilters(context, filters) {
      context.commit('setTicketFilters', filters);
    },
    resetTicketFilters(context) {
      context.commit('resetTicketFilters');
    },
    setComprehensiveReportFilters(context, filters) {
      context.commit('setComprehensiveReportFilters', filters);
    },
    resetComprehensiveReportFilters(context) {
      context.commit('resetComprehensiveReportFilters');
    },
    setComprehensiveReportResults(context, results) {
      context.commit('setComprehensiveReportResults', results);
    },
    resetComprehensiveReportResults(context) {
      context.commit('resetComprehensiveReportResults');
    },
    addListNewNotifications(context, notifications) {
      // let myTicketsNotifications = notifications.filter(x => [1, 5].includes(x.ticketNotificationEventEnum));
      // let referralNotifications = notifications.filter(x => [2, 4, 6].includes(x.ticketNotificationEventEnum));
      
      let myTicketsNotifications = notifications.filter(x => [1, 2, 6].includes(x.userTicketRelationEnum));
      let referralNotifications = notifications.filter(x => [5, 6].includes(x.userTicketRelationEnum));
      
      context.commit('addListMyTicketsNotifications', myTicketsNotifications);
      context.commit('addListNewReferralNotifications', referralNotifications);
    },
    addListMyTicketsNotifications(context, notifications) {
      context.commit('addListMyTicketsNotifications', notifications);
    },
    addListNewReferralNotifications(context, notifications) {
      context.commit('addListNewReferralNotifications', notifications);
    },
    removeListFromNotificationsByTicketIds(context, ticketIds) {
      let allNotifications = [...context.state.myTicketsNotifications, ...context.state.newReferralNotifications];
      allNotifications.filter((value, index, array) => index == array.findIndex(n => n.ticketId == value.ticketId));

      ticketIds = allNotifications.filter(rn => ticketIds.includes(rn.ticketId)).map(rn => rn.ticketId);

      if (ticketIds.length > 0) {
        let filterVM = {
          ticketIds,
          ticketNotificationEventEnums: [1, 2, 4, 5, 6],
        };
        
        TicketNotificationService.setRangeTicketNotificationsByTicketIdsToSeenByCurrentUser(filterVM).then(response => {
          let result = response.data;
          
          if (result.success) {
            context.commit('removefromMyTicketsNotifications', { ticketIds, source: 'local' });
            context.commit('removefromReferredTicketsNotifications', { ticketIds, source: 'local' });
          }
          else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }
    },
    removefromMyTicketsNotifications(context, ticketIds) {
      context.commit('removefromMyTicketsNotifications', { ticketIds, source: 'local' });
    },
    removefromReferredTicketsNotifications(context, ticketIds) {
      context.commit('removefromReferredTicketsNotifications', { ticketIds, source: 'local' });
    },
    emptyNotificationLists(context) {
      context.commit('emptyNotificationLists');
    }
  },
  getters: {
    currentUserPermissions(state){
      return state.currentUserInfo.permissions;
    },
    currentUser_username(state) {
      if (!state.currentUserInfo || !state.currentUserInfo.userName) return '';
      return state.currentUserInfo.userName;
    },
    currentUser_list_perms(state) {
      if (!state.currentUserInfo || !state.currentUserInfo.list_permission) return [];
      return state.currentUserInfo.list_permission;
    },
    getTicketFilters(state) {
      return state.ticketFilters;
    },
    getComprehensiveReportFilters(state) {
      return state.comprehensiveReportFilters;
    },
    getComprehensiveReportResults(state) {
      return state.comprehensiveReportResults;
    },
    currentUserInfo(state) {
      return state.currentUserInfo;
    },
    getPermission: (_, getters) => (code) => {
      let index = getters.currentUserPermissions?.findIndex((v) => { return v.permissionCode == code });

      if (!(index > -1)) {
        return { view: false, insert: false, update: false, delete: false };
      }
      else {
        return getters.currentUserPermissions[index];
      }
    },
    newReferralNotifications(state) {
      return state.newReferralNotifications;
    },
    myTicketsNotifications(state) {
      return state.myTicketsNotifications;
    },
    currentUser_permByCode: (state, getters) => (perm_code) => {

      return {
        canView: true,
        canInsert: true,
        canUpdate: true,
        canDelete: true,
        canUndo_delete: true,
        canSearch: true,
        canPrint: true
      };


      //return state.form_access_info.successResult;
      if (!state.currentUserInfo || !state.currentUserInfo.list_permission) return state.form_access_info.failResult;

      let result_Perm = {
        canView: false,
        canInsert: false,
        canUpdate: false,
        canDelete: false,
        canUndo_delete: false,
        canSearch: false,
        canPrint: false
      };

      let prms = state.currentUserInfo.list_permission.filter((vp, ip) => { return vp.code == perm_code; });

      if (prms.length == 0) {
        return state.form_access_info.failResult;
      }

      for (var k = 0; k < prms.length; k++) {

        let permItem = prms[k];

        if (!(result_Perm.canView ?? false)) {
          result_Perm.canView = permItem.canView ?? false;
        }
        if (!(result_Perm.canInsert ?? false)) {
          result_Perm.canInsert = permItem.canInsert ?? false;
        }
        if (!(result_Perm.canUpdate ?? false)) {
          result_Perm.canUpdate = permItem.canUpdate ?? false;
        }
        if (!(result_Perm.canDelete ?? false)) {
          result_Perm.canDelete = permItem.canDelete ?? false;
        }
        if (!(result_Perm.canUndo_delete ?? false)) {
          result_Perm.canUndo_delete = permItem.canUndo_delete ?? false;
        }
        if (!(result_Perm.canPrint ?? false)) {
          result_Perm.canPrint = permItem.canPrint ?? false;
        }
        if (!(result_Perm.canSearch ?? false)) {
          result_Perm.canSearch = permItem.canSearch ?? false;
        }
      }

      return result_Perm;

    },
    currentUser_PermByParentCode: (state, getters) => (perm_code) => {
      if (!state.currentUserInfo || !state.currentUserInfo.list_permission) return [];
      let perms = state.currentUserInfo.list_permission.filter((v, i) => { return v.facilityTypeCode == perm_code; });
      return perms;
    },
    get_api_url(state) {
      if (state.$api_base_url && state.$api_base_url != '') return state.$api_base_url;
      return window.location.origin + '/api';
    },
    currentUser_organTypeCode(state) {
      if (!state.currentUserInfo || !state.currentUserInfo.organTypeCode) return 0;
      return state.currentUserInfo.organTypeCode;
    },
    getExprotExcelFileName: (state, getters) => (parameterGroupEnum, year, month) => {
      let paramItem = state.listParameterGroups.filter((v, i) => {
        return v.parameterGroupEnum == parameterGroupEnum;
      });

      if (paramItem.length == 0)
        return 'دریافت فایل خروجی ' + year.toString() + month;
      else
        return paramItem[0].title + '-' + year.toString() + month;

    }
  }

});

store.subscribe((mutation) => {
  if ((mutation.type == 'removefromReferredTicketsNotifications' | mutation.type == 'removefromMyTicketsNotifications')
      & mutation.payload?.source == 'local')
  {
    syncChannel.postMessage({
      source: store.state.tabId,
      type: mutation.type,
      payload: mutation.payload
    });
  }
});

syncChannel.onmessage = ({ data }) => {
  store.commit(data.type, { ...data.payload, source: 'broadcast' });
};

export default store;
